import { GridColDef } from '@mui/x-data-grid-pro';

export const getGridTemplateColumns = (columns: GridColDef[]) =>
  '40px ' +
  columns.map((c) => (c.width ? c.width + 'px' : '1fr')).join(' ') +
  ' 40px'; // +1 for the menu column
